export default __webpack_public_path__ + "static/media/SmallMediumBreastedPutOnBraCorrectlyFinalCut.88191ba1.png";